import { Component, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import * as Chartist from 'chartist';
import { ChartType, ChartEvent } from "ng-chartist";
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
import { ApiService } from 'app/shared/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'environments/environment';
import { DynamicDetailComponent } from 'app/pages/full-pages/admin/dynamic-detail/dynamic-detail.component';
import { Router } from '@angular/router';


declare var require: any;

const data: any = require('../../shared/data/chartist.json');

export interface Chart {
  type: ChartType;
  data: Chartist.IChartistData;
  options?: any; 
  responsiveOptions?: any;
  events?: ChartEvent;
  // plugins?: any;
}
export interface DynamicDetailData {
  id: number;
  key: string;
  value: string;
}

@Component({
  selector: 'app-dashboard1',
  templateUrl: './dashboard1.component.html',
  styleUrls: ['./dashboard1.component.scss']
})

export class Dashboard1Component {
  usersLength:any;
  courseLength:any;
  studentLength:any;
  businessLength:any;
  monthlyData=[]
  monthlyTransactionData: any={};
  monthData:any={}
  courseId:any
  employeeData:any
  monthlyVisitData:any={}
  lineChartData:any={}
  barData:any={}
  courseNo:any
  userNo:any
  studentNo:any
  collegeNo:any
  newArray=[]
  imageUrl=environment.apiUrls.imageUrl;
  selectedMonth:any=new Date().getMonth()+1;
  selectedYear:any=new Date().getFullYear();
  row_data:any
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: false }) dynamicContainer: ViewContainerRef;
  guideline_data:any
  courseCount:any
  constructor(private apiService:ApiService,private route: Router,
    private spinner: NgxSpinnerService,private resolver: ComponentFactoryResolver){}
  ngOnInit(){
    this.getSettingList()
    this.filterSetting('Dashboard')
    this.getAllRecord();
    this.getCourseList();
    // this.getAllStudents();
    // this.getAllBusinessList();
    this.calculateTransaction();
    this.calculatesTransaction();
    this.sixMonthData();
    this.getEmployeeList();
    this.monthlyVisitEnrolment();
    this.barMonthData();
  }
getAllRecord(){
  this.apiService.getAllRecords().subscribe((res:any)=>{
    this.usersLength = res?.data?.UserCount
    this.studentLength = res?.data?.StudentCount
    this.businessLength = res?.data?.BusinessCount
    this.courseCount = res?.data?.CourseCount
  //  this.usersLength=res.data.items
    // this.userNo=this.usersLength.length
  })
}
getAllStudents(){
  this.apiService.getAllStudents(1,100).subscribe((res:any)=>{
    this.studentLength= res.items
    this.studentNo=this.studentLength.length
  })
}
getAllBusinessList(){
  this.apiService.getBusinessList(1,500).subscribe((res:any)=>{
    this.businessLength =res.data.items
    this.collegeNo=this.businessLength.length
  })
}
getCourseList(){
  this.apiService.getCourseList(1,100).subscribe((res:any)=>{
    this.courseLength=res?.data?.items
  })

 }
 calculatesTransaction(){
  this.spinner.show(undefined,
    {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });
    this.apiService.getTransactionByMonth(this.selectedMonth,this.selectedYear).subscribe((res:any)=>{
       this.monthlyData=res?.data
       this.spinner.hide();

    })
  }
 calculateTransaction(){
  this.apiService.getTransactionByMonth(this.selectedMonth,this.selectedYear).subscribe((res:any)=>{
     this.monthlyTransactionData=res?.data
     let transData=[]
     for(let item of this.monthlyTransactionData){
      let index = this.monthlyTransactionData.indexOf(item)
      let className=''
      if(index==0 ){
       className="ct-done"
      }
      else if(index ==1){
        className="ct-started"
      }
      else if(index ==2){
        className="ct-progress"
      }
      else if(index ==3){
        className="ct-outstanding"
      }
     let trans={
      name:item._id,    
      className: className,
      MonthReceivedAmount: item.MonthReceivedAmount,

      count: item.count,
      amountTotal: item.amountTotal,
      value: Number(item.percentage)
     }
     transData.push(trans)

     }

     let dataModify={}
     dataModify['series']=transData
     this.monthlyTransactionData=dataModify
    this.DonutChart = {
      type: 'Pie',
      data: this.monthlyTransactionData,
      options: {
        donut: true,
        startAngle: 0,
        labelInterpolationFnc: function (value) {
          var total = this.monthlyTransactionData?.series.reduce(function (prev, series) {
            return prev + series.value;
          }, 0);
      
          return 100 + '%';
        }
      },
      events: {
        draw(data: any): void {
          if (data.type === 'label') {
            if (data.index === 0) {
              data.element.attr({
                dx: data.element.root().width() / 2,
                dy: data.element.root().height() / 2
              });
            } else {
              data.element.remove();
            }
          }
  
        }
      }
    };
  })
}
barMonthData(){
  this.apiService.getTransactionByMonth(this.selectedMonth,this.selectedYear).subscribe((res:any)=>{
    this.monthData=res.data

    let transferData=[]
    let monthly=[]
   
      const newData=this.monthData.map(function(e){
           return e.MonthReceivedAmount
        })
    
      const monthsData=this.monthData.map(function(e){
        return e._id
     })
     
    // ------------------bar chart--------------------------------------------------
    let labelArray=['User','Student','College','Course']
    this.newArray.push(this.userNo,this.studentNo,this.collegeNo,this.courseNo)
    let accountData={}
    accountData['labels']=labelArray
    accountData['series']=[this.newArray]
    this.barData=accountData
  // ------------------------------------------------------------------------
    
    
// -------------------------barchart--------------------------------------------------------------------------------
    this.BarChart= {
  type: 'Bar',
   data: this.barData, 
  options: {
    axisX: {
      showGrid: false,
    },
    axisY: {
      showGrid: false,
      showLabel: false,
      offset: 0
    },
    low: 0,
    high: 400, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
  },
  responsiveOptions: [
    ['screen and (max-width: 640px)', {
      seriesBarDistance: 5,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value;
        }
      }
    }]
  ],
  events: {
    created(data: any): void {
      var defs = data.svg.elem('defs');
      defs.elem('linearGradient', {
        id: 'gradient4',
        x1: 0,
        y1: 1,
        x2: 0,
        y2: 0
      }).elem('stop', {
        offset: 0,
        'stop-color': '#8E1A38'
      }).parent().elem('stop', {
        offset: 1,
        'stop-color': '#FAA750'
      });
      defs.elem('linearGradient', {
        id: 'gradient5',
        x1: 0,
        y1: 1,
        x2: 0,
        y2: 0
      }).elem('stop', {
        offset: 0,
        'stop-color': '#1750A5'
      }).parent().elem('stop', {
        offset: 1,
        'stop-color': '#40C057'
      });

      defs.elem('linearGradient', {
        id: 'gradient6',
        x1: 0,
        y1: 1,
        x2: 0,
        y2: 0
      }).elem('stop', {
        offset: 0,
        'stop-color': '#3B1C93'
      }).parent().elem('stop', {
        offset: 1,
        'stop-color': '#60AFF0'
      });
      defs.elem('linearGradient', {
        id: 'gradient7',
        x1: 0,
        y1: 1,
        x2: 0,
        y2: 0
      }).elem('stop', {
        offset: 0,
        'stop-color': '#562DB7'
      }).parent().elem('stop', {
        offset: 1,
        'stop-color': '#F55252'
      });

    },
    draw(data: any): void {
      if (data.type === 'bar') {

        data.element.attr({
          y1: 195,
          x1: data.x1 + 0.001
        });

      }
    }
  },

};

  })
}
sixMonthData(){
  this.apiService.getTransactionByMonth(this.selectedMonth,this.selectedYear).subscribe((res:any)=>{
    this.monthData=res.data

    let transferData=[]
    let monthly=[]
    // for(let item of this.monthData){
    //   let amountData= {
    //     monthAmount:item.MonthReceivedAmount,
    //   }
      // transferData.push(amountData) 
      const newData=this.monthData.map(function(e){
           return e.MonthReceivedAmount
        })
      // let monthRelateData={
      //   month:item._id
      // }
      // monthly.push(monthRelateData)
      const monthsData=this.monthData.map(function(e){
        return e._id
     })
     let arry3=[100000,177000,66000,203000]
    // -------------linechart data------------------------------------------------
    let amountTotal={}
     amountTotal['labels']=monthsData
     amountTotal['series']=[newData]
     this.lineChartData=amountTotal
    //  -------------end-------------------------------------------------------------
    // ------------------bar chart--------------------------------------------------
  //   let labelArray=['User','Student','College','Course']
  //  this.newArray.push(this.userNo,this.studentNo,this.collegeNo,this.courseNo)
  // let accountData={}
  // accountData['labels']=labelArray
  // accountData['series']=[this.newArray]
  // this.barData=accountData
  // ------------------------------------------------------------------------
    
      let modify={}
      modify['labels'] =monthsData
      modify['series']=[newData,arry3]
      this.monthData=modify
    // let modify={}
    // modify['series']=transferData
    // this.monthData=modify
    // const newData=this.monthData.map(function(e){
    //   return e.MonthReceivedAmount
    // })
    
    this.Stackbarchart = {
      type: 'Bar',
      data: this.monthData,
      options: {
        stackBars: true,
        fullWidth: true,
        axisX: {
          showGrid: false,
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        chartPadding: 30
      },
      events: {
        created(data: any): void {
          var defs = data.svg.elem('defs');
          defs.elem('linearGradient', {
            id: 'linear',
            x1: 0,
            y1: 1,
            x2: 0,
            y2: 0
          }).elem('stop', {
            offset: 0,
            'stop-color': '#7441DB'
          }).parent().elem('stop', {
            offset: 1,
            'stop-color': '#C89CFF'
          });
        },
        draw(data: any): void {
          if (data.type === 'bar') {
            data.element.attr({
              style: 'stroke-width: 5px',
              x1: data.x1 + 0.001
            });
  
          }
          else if (data.type === 'labels') {
            data.element.attr({
              y: 270
            })
          }
        }
      },
    };
// -------------------------barchart--------------------------------------------------------------------------------
//     this.BarChart= {
//   type: 'Bar',
//    data: this.barData, 
//   options: {
//     axisX: {
//       showGrid: false,
//     },
//     axisY: {
//       showGrid: false,
//       showLabel: false,
//       offset: 0
//     },
//     low: 0,
//     high: 400, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
//   },
//   responsiveOptions: [
//     ['screen and (max-width: 640px)', {
//       seriesBarDistance: 5,
//       axisX: {
//         labelInterpolationFnc: function (value) {
//           return value;
//         }
//       }
//     }]
//   ],
//   events: {
//     created(data: any): void {
//       var defs = data.svg.elem('defs');
//       defs.elem('linearGradient', {
//         id: 'gradient4',
//         x1: 0,
//         y1: 1,
//         x2: 0,
//         y2: 0
//       }).elem('stop', {
//         offset: 0,
//         'stop-color': '#8E1A38'
//       }).parent().elem('stop', {
//         offset: 1,
//         'stop-color': '#FAA750'
//       });
//       defs.elem('linearGradient', {
//         id: 'gradient5',
//         x1: 0,
//         y1: 1,
//         x2: 0,
//         y2: 0
//       }).elem('stop', {
//         offset: 0,
//         'stop-color': '#1750A5'
//       }).parent().elem('stop', {
//         offset: 1,
//         'stop-color': '#40C057'
//       });

//       defs.elem('linearGradient', {
//         id: 'gradient6',
//         x1: 0,
//         y1: 1,
//         x2: 0,
//         y2: 0
//       }).elem('stop', {
//         offset: 0,
//         'stop-color': '#3B1C93'
//       }).parent().elem('stop', {
//         offset: 1,
//         'stop-color': '#60AFF0'
//       });
//       defs.elem('linearGradient', {
//         id: 'gradient7',
//         x1: 0,
//         y1: 1,
//         x2: 0,
//         y2: 0
//       }).elem('stop', {
//         offset: 0,
//         'stop-color': '#562DB7'
//       }).parent().elem('stop', {
//         offset: 1,
//         'stop-color': '#F55252'
//       });

//     },
//     draw(data: any): void {
//       var barHorizontalCenter, barVerticalCenter, label, value;
//       if (data.type === 'bar') {

//         data.element.attr({
//           y1: 195,
//           x1: data.x1 + 0.001
//         });

//       }
//     }
//   },

// };

    // -----------------------linechart-----------------------------------
    this.lineChart= {
      type: 'Line', data: this.lineChartData,
      options: {
        axisX: {
          showGrid: false
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          low: 0,
          high: 200000,
          offset: 0,
        },
        plugins: [
          ChartistTooltip({
            appendToBody: true,
            currency: '$',
            pointClass: 'ct-point-circle'
          })
        ],
        fullWidth: true,
        offset: 0,
      },
      events: {
        draw(data: any): void {
          var circleRadius = 4;
          if (data.type === 'point') {
            var circle = new Chartist.Svg('circle', {
              cx: data.x,
              cy: data.y,
              r: circleRadius,
              'ct:value': data.value.y,
              'ct:meta': data.meta,
              style: 'pointer-events: all !important',
              class: 'ct-point-circle'
            });
  
            data.element.replace(circle);
          }
          else if (data.type === 'label') {
            // adjust label position for rotation
            const dX = data.width / 2 + (30 - data.width)
            data.element.attr({ x: data.element.attr('x') - dX })
          }
        }
      },
  
    };
    

  })
}
getEmployeeList(){
    this.apiService.getEmployeeList(1,100).subscribe((res:any)=>{
    this.employeeData=res.items
  })
}
monthlyVisitEnrolment(){
  this.apiService.monthlyVisitEnrolment(1,100).subscribe((res:any)=>{
    this.monthlyVisitData=res.data.items
    let visitData=[]
    const visit =this.monthlyVisitData.map(function(e){
      return e.enrolment
   })
   const visit2 =this.monthlyVisitData.map(function(e){
    return e.month
 })
   let newModifyData={}
   newModifyData['labels']=[visit2]
   newModifyData['series']=[visit]
   this.monthlyVisitData=newModifyData

  //  this.lineArea2 = {
  //   type: 'Line',
  //   data: this.monthlyVisitData,
  //   options: {
  //     showArea: true,
  //     fullWidth: true,
  //     lineSmooth: Chartist.Interpolation.none(),
  //     axisX: {
  //       showGrid: false,
  //     },
  //     axisY: {
  //       low: 0,
  //       scaleMinSpace: 50
  //     },
  //     plugins: [
  //       ChartistTooltip({
  //         appendToBody: true,
  //         pointClass: 'ct-point-circle'
  //       })
  //     ],
  //   },
  //   responsiveOptions: [
  //     ['screen and (max-width: 640px) and (min-width: 381px)', {
  //       axisX: {
  //         labelInterpolationFnc: function (value, index) {
  //           return index % 2 === 0 ? value : null;
  //         }
  //       }
  //     }],
  //     ['screen and (max-width: 380px)', {
  //       axisX: {
  //         labelInterpolationFnc: function (value, index) {
  //           return index % 3 === 0 ? value : null;
  //         }
  //       }
  //     }]
  //   ],
  //   events: {
  //     created(data: any): void {
  //       var defs = data.svg.elem('defs');
  //       defs.elem('linearGradient', {
  //         id: 'gradient2',
  //         x1: 0,
  //         y1: 1,
  //         x2: 0,
  //         y2: 0
  //       }).elem('stop', {
  //         offset: 0,
  //         'stop-opacity': '0.2',
  //         'stop-color': 'transparent'
  //       }).parent().elem('stop', {
  //         offset: 1,
  //         'stop-opacity': '0.2',
  //         'stop-color': '#60AFF0'
  //       });

  //       defs.elem('linearGradient', {
  //         id: 'gradient3',
  //         x1: 0,
  //         y1: 1,
  //         x2: 0,
  //         y2: 0
  //       }).elem('stop', {
  //         offset: 0.3,
  //         'stop-opacity': '0.2',
  //         'stop-color': 'transparent'
  //       }).parent().elem('stop', {
  //         offset: 1,
  //         'stop-opacity': '0.2',
  //         'stop-color': '#6CD975'
  //       });
  //     },
  //     draw(data: any): void {
  //       var circleRadius = 4;
  //       if (data.type === 'point') {

  //         var circle = new Chartist.Svg('circle', {
  //           cx: data.x,
  //           cy: data.y,
  //           r: circleRadius,
  //           'ct:value': data.value.y,
  //           'ct:meta': data.meta,
  //           style: 'pointer-events: all !important',
  //           class: 'ct-point-circle'
  //         });
  //         data.element.replace(circle);
  //       }
  //       else if (data.type === 'label') {
  //         // adjust label position for rotation
  //         const dX = data.width / 2 + (30 - data.width)
  //         data.element.attr({ x: data.element.attr('x') - dX })
  //       }
  //     }
  //   },
  // };

   
//     for(let item of this.monthlyVisitData){
//     let visit={
// monthVisit:item.enrolment
//     }
//     visitData.push(visit)
//   }
    // this.lineArea = {
    //   type: 'Line',
    //   data: this.monthlyVisitData,
    //   options: {
    //     low: 0,
    //     showArea: true,
    //     fullWidth: true,
    //     onlyInteger: true,
    //     axisY: {
    //       low: 0,
    //       scaleMinSpace: 50,
    //     },
    //     plugins: [
    //       ChartistTooltip({
    //         appendToBody: true,
    //         pointClass: 'ct-point-regular'
    //       })
    //     ],
    //     axisX: {
    //       showGrid: false
    //     }
    //   },
    //   events: {
    //     created(data: any): void {
    //       var defs = data.svg.elem('defs');
    //       defs.elem('linearGradient', {
    //         id: 'gradient',
    //         x1: 0,
    //         y1: 1,
    //         x2: 1,
    //         y2: 0
    //       }).elem('stop', {
    //         offset: 0,
    //         'stop-color': 'rgba(0, 201, 255, 1)'
    //       }).parent().elem('stop', {
    //         offset: 1,
    //         'stop-color': 'rgba(146, 254, 157, 1)'
    //       });
  
    //       defs.elem('linearGradient', {
    //         id: 'gradient1',
    //         x1: 0,
    //         y1: 1,
    //         x2: 1,
    //         y2: 0
    //       }).elem('stop', {
    //         offset: 0,
    //         'stop-color': 'rgba(132, 60, 247, 1)'
    //       }).parent().elem('stop', {
    //         offset: 1,
    //         'stop-color': 'rgba(56, 184, 242, 1)'
    //       });
    //     },
    //     draw(data: any): void {
    //       if (data.type === 'point') {
    //         var circle = new Chartist.Svg('circle', {
    //           cx: data.x,
    //           cy: data.y,
    //           r: 4,
    //           'ct:value': data.value.y,
    //           'ct:meta': data.meta,
    //           style: 'pointer-events: all !important',
    //           class: 'ct-point-regular'
    //         });
    //         data.element.replace(circle);
    //       }
    //     }
    //   },
    // };

  })
}
  
  
  // Line area chart configuration Starts
  lineArea: Chart = {
    type: 'Line',
    data: data['lineAreaDashboard'],
    options: {
      low: 0,
      showArea: true,
      fullWidth: true,
      onlyInteger: true,
      axisY: {
        low: 0,
        scaleMinSpace: 50,
      },
      plugins: [
        ChartistTooltip({
          appendToBody: true,
          pointClass: 'ct-point-regular'
        })
      ],
      axisX: {
        showGrid: false
      }
    },
    events: {
      created(data: any): void {
        var defs = data.svg.elem('defs');
        defs.elem('linearGradient', {
          id: 'gradient',
          x1: 0,
          y1: 1,
          x2: 1,
          y2: 0
        }).elem('stop', {
          offset: 0,
          'stop-color': 'rgba(0, 201, 255, 1)'
        }).parent().elem('stop', {
          offset: 1,
          'stop-color': 'rgba(146, 254, 157, 1)'
        });

        defs.elem('linearGradient', {
          id: 'gradient1',
          x1: 0,
          y1: 1,
          x2: 1,
          y2: 0
        }).elem('stop', {
          offset: 0,
          'stop-color': 'rgba(132, 60, 247, 1)'
        }).parent().elem('stop', {
          offset: 1,
          'stop-color': 'rgba(56, 184, 242, 1)'
        });
      },
      draw(data: any): void {
        if (data.type === 'point') {
          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: 4,
            'ct:value': data.value.y,
            'ct:meta': data.meta,
            style: 'pointer-events: all !important',
            class: 'ct-point-regular'
          });
          data.element.replace(circle);
        }
      }
    },
  };
  // Line area chart configuration Ends

  // Stacked Bar chart configuration Starts
  Stackbarchart: Chart = {
    type: 'Bar',
    data: data['Stackbarchart'],
    options: {
      stackBars: true,
      fullWidth: true,
      axisX: {
        showGrid: false,
      },
      axisY: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      chartPadding: 30
    },
    events: {
      created(data: any): void {
        var defs = data.svg.elem('defs');
        defs.elem('linearGradient', {
          id: 'linear',
          x1: 0,
          y1: 1,
          x2: 0,
          y2: 0
        }).elem('stop', {
          offset: 0,
          'stop-color': '#7441DB'
        }).parent().elem('stop', {
          offset: 1,
          'stop-color': '#C89CFF'
        });
      },
      draw(data: any): void {
        if (data.type === 'bar') {
          data.element.attr({
            style: 'stroke-width: 5px',
            x1: data.x1 + 0.001
          });

        }
        else if (data.type === 'labels') {
          data.element.attr({
            y: 270
          })
        }
      }
    },
  };
  // Stacked Bar chart configuration Ends

  // Line area chart 2 configuration Starts
  lineArea2: Chart = {
    type: 'Line',
    data: data['lineArea2'],
    options: {
      showArea: true,
      fullWidth: true,
      lineSmooth: Chartist.Interpolation.none(),
      axisX: {
        showGrid: false,
      },
      axisY: {
        low: 0,
        scaleMinSpace: 50
      },
      plugins: [
        ChartistTooltip({
          appendToBody: true,
          pointClass: 'ct-point-circle'
        })
      ],
    },
    responsiveOptions: [
      ['screen and (max-width: 640px) and (min-width: 381px)', {
        axisX: {
          labelInterpolationFnc: function (value, index) {
            return index % 2 === 0 ? value : null;
          }
        }
      }],
      ['screen and (max-width: 380px)', {
        axisX: {
          labelInterpolationFnc: function (value, index) {
            return index % 3 === 0 ? value : null;
          }
        }
      }]
    ],
    events: {
      created(data: any): void {
        var defs = data.svg.elem('defs');
        defs.elem('linearGradient', {
          id: 'gradient2',
          x1: 0,
          y1: 1,
          x2: 0,
          y2: 0
        }).elem('stop', {
          offset: 0,
          'stop-opacity': '0.2',
          'stop-color': 'transparent'
        }).parent().elem('stop', {
          offset: 1,
          'stop-opacity': '0.2',
          'stop-color': '#60AFF0'
        });

        defs.elem('linearGradient', {
          id: 'gradient3',
          x1: 0,
          y1: 1,
          x2: 0,
          y2: 0
        }).elem('stop', {
          offset: 0.3,
          'stop-opacity': '0.2',
          'stop-color': 'transparent'
        }).parent().elem('stop', {
          offset: 1,
          'stop-opacity': '0.2',
          'stop-color': '#6CD975'
        });
      },
      draw(data: any): void {
        var circleRadius = 4;
        if (data.type === 'point') {

          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: circleRadius,
            'ct:value': data.value.y,
            'ct:meta': data.meta,
            style: 'pointer-events: all !important',
            class: 'ct-point-circle'
          });
          data.element.replace(circle);
        }
        else if (data.type === 'label') {
          // adjust label position for rotation
          const dX = data.width / 2 + (30 - data.width)
          data.element.attr({ x: data.element.attr('x') - dX })
        }
      }
    },
  };
  // Line area chart 2 configuration Ends

  // Line chart configuration Starts
  lineChart: Chart = {
    type: 'Line', data: data['LineDashboard'],
    options: {
      axisX: {
        showGrid: false
      },
      axisY: {
        showGrid: false,
        showLabel: false,
        low: 0,
        high: 100,
        offset: 0,
      },
      plugins: [
        ChartistTooltip({
          appendToBody: true,
          currency: '$',
          pointClass: 'ct-point-circle'
        })
      ],
      fullWidth: true,
      offset: 0,
    },
    events: {
      draw(data: any): void {
        var circleRadius = 4;
        if (data.type === 'point') {
          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: circleRadius,
            'ct:value': data.value.y,
            'ct:meta': data.meta,
            style: 'pointer-events: all !important',
            class: 'ct-point-circle'
          });

          data.element.replace(circle);
        }
        else if (data.type === 'label') {
          // adjust label position for rotation
          const dX = data.width / 2 + (30 - data.width)
          data.element.attr({ x: data.element.attr('x') - dX })
        }
      }
    },

  };
  // Line chart configuration Ends

  // Donut chart configuration Starts
  DonutChart: Chart = {
    type: 'Pie',
    data: this.monthlyTransactionData,
    options: {
      donut: true,
      startAngle: 0,
      labelInterpolationFnc: function (value) {
        var total = this.monthlyTransactionData.series.reduce(function (prev, series) {
          return prev + series.value;
        }, 0);
        return total + '%';
      }
    },
    events: {
      draw(data: any): void {
        if (data.type === 'label') {
          if (data.index === 0) {
            data.element.attr({
              dx: data.element.root().width() / 2,
              dy: data.element.root().height() / 2
            });
          } else {
            data.element.remove();
          }
        }

      }
    }
  };
  // Donut chart configuration Ends

  //  Bar chart configuration Starts
  BarChart: Chart = {
    type: 'Bar', data: data['DashboardBar'], options: {
      axisX: {
        showGrid: false,
      },
      axisY: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      low: 0,
      high: 60, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
    },
    responsiveOptions: [
      ['screen and (max-width: 640px)', {
        seriesBarDistance: 5,
        axisX: {
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }
      }]
    ],
    events: {
      created(data: any): void {
        var defs = data.svg.elem('defs');
        defs.elem('linearGradient', {
          id: 'gradient4',
          x1: 0,
          y1: 1,
          x2: 0,
          y2: 0
        }).elem('stop', {
          offset: 0,
          'stop-color': '#8E1A38'
        }).parent().elem('stop', {
          offset: 1,
          'stop-color': '#FAA750'
        });
        defs.elem('linearGradient', {
          id: 'gradient5',
          x1: 0,
          y1: 1,
          x2: 0,
          y2: 0
        }).elem('stop', {
          offset: 0,
          'stop-color': '#1750A5'
        }).parent().elem('stop', {
          offset: 1,
          'stop-color': '#40C057'
        });

        defs.elem('linearGradient', {
          id: 'gradient6',
          x1: 0,
          y1: 1,
          x2: 0,
          y2: 0
        }).elem('stop', {
          offset: 0,
          'stop-color': '#3B1C93'
        }).parent().elem('stop', {
          offset: 1,
          'stop-color': '#60AFF0'
        });
        defs.elem('linearGradient', {
          id: 'gradient7',
          x1: 0,
          y1: 1,
          x2: 0,
          y2: 0
        }).elem('stop', {
          offset: 0,
          'stop-color': '#562DB7'
        }).parent().elem('stop', {
          offset: 1,
          'stop-color': '#F55252'
        });

      },
      draw(data: any): void {
        var barHorizontalCenter, barVerticalCenter, label, value;
        if (data.type === 'bar') {

          data.element.attr({
            y1: 195,
            x1: data.x1 + 0.001
          });

        }
      }
    },

  };
  // Bar chart configuration Ends

  // line chart configuration Starts
  WidgetlineChart: Chart = {
    type: 'Line', data: data['Dashboard1_WidgetlineChart'],
    options: {
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      axisY: {
        showGrid: false,
        low: 40,
        showLabel: false,
        offset: 0
      },
      plugins: [
        ChartistTooltip({
          appendToBody: true,
          currency: '$',
          pointClass: 'ct-point-regular'
        })
      ],
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      fullWidth: true
    },
    events: {
      draw(data: any): void {
        if (data.type === 'point') {
          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: 4,
            'ct:value': data.value.y,
            'ct:meta': data.meta,
            style: 'pointer-events: all !important',
            class: 'ct-point-regular'
          });
          data.element.replace(circle);
        }
      }
    }
  };
  // Line chart configuration Ends

    // line chart configuration Starts
    WidgetlineChart1: Chart = {
      type: 'Line', data: data['Dashboard1_WidgetlineChart1'],
      options: {
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        axisY: {
          showGrid: false,
          low: 40,
          showLabel: false,
          offset: 0
        },
        plugins: [
          ChartistTooltip({
            appendToBody: true,
            currency: '$',
            pointClass: 'ct-point-regular'
          })
        ],
        lineSmooth: Chartist.Interpolation.cardinal({
          tension: 0
        }),
        fullWidth: true
      },
      events: {
        draw(data: any): void {
          if (data.type === 'point') {
            var circle = new Chartist.Svg('circle', {
              cx: data.x,
              cy: data.y,
              r: 4,
              'ct:value': data.value.y,
              'ct:meta': data.meta,
              style: 'pointer-events: all !important',
              class: 'ct-point-regular'
            });
            data.element.replace(circle);
          }
        }
      }
    };
    // Line chart configuration Ends

      // line chart configuration Starts
  WidgetlineChart2: Chart = {
    type: 'Line', data: data['Dashboard1_WidgetlineChart2'],
    options: {
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      axisY: {
        showGrid: false,
        low: 40,
        showLabel: false,
        offset: 0
      },
      plugins: [
        ChartistTooltip({
          appendToBody: true,
          currency: '$',
          pointClass: 'ct-point-regular'
        })
      ],
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      fullWidth: true
    },
    events: {
      draw(data: any): void {
        if (data.type === 'point') {
          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: 4,
            'ct:value': data.value.y,
            'ct:meta': data.meta,
            style: 'pointer-events: all !important',
            class: 'ct-point-regular'
          });
          data.element.replace(circle);
        }
      }
    }
  };
  // Line chart configuration Ends

    // line chart configuration Starts
    WidgetlineChart3: Chart = {
      type: 'Line', data: data['Dashboard1_WidgetlineChart3'],
      options: {
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        axisY: {
          showGrid: false,
          low: 40,
          showLabel: false,
          offset: 0
        },
        plugins: [
          ChartistTooltip({
            appendToBody: true,
            currency: '$',
            pointClass: 'ct-point-regular'
          })
        ],
        lineSmooth: Chartist.Interpolation.cardinal({
          tension: 0
        }),
        fullWidth: true
      },
      events: {
        draw(data: any): void {
          if (data.type === 'point') {
            var circle = new Chartist.Svg('circle', {
              cx: data.x,
              cy: data.y,
              r: 4,
              'ct:value': data.value.y,
              'ct:meta': data.meta,
              style: 'pointer-events: all !important',
              class: 'ct-point-regular'
            });
            data.element.replace(circle);
          }
        }
      }
    };
    // Line chart configuration Ends

  onResized(event: any) {
    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };
  getSettingList(){
    this.apiService.getAllSetting(1,100).subscribe((res:any)=>{
      let data = res?.items
      let setting_data = JSON.stringify(data)
      if(setting_data){
        localStorage.setItem('setting-record', setting_data)
      }
    })
  }

  createDynamicComponent(data:DynamicDetailData) {
    this.row_data =data
    // Create a factory for the dynamic component
    const factory = this.resolver.resolveComponentFactory(DynamicDetailComponent);

    // Create an instance of the dynamic component
    const componentRef = factory.create(this.dynamicContainer.injector);

    // Set the data for the dynamic component
    componentRef.instance.data = data;

    // Insert the dynamic component into the view container
    this.dynamicContainer.insert(componentRef.hostView);
  }

  filterSetting(data){
    this.apiService.searchSettings(data).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.guideline_data = res?.data?.items
        this.createDynamicComponent(this.guideline_data[1]?this.guideline_data[1]:this.guideline_data[0])
      }
    })
  
  }
 

}
